module.exports = __webpack_public_path__ + "img/purpleClose.502de400.png";